import { type ILogLayer } from "@-/com.npmjs.loglayer";
import { SentryTransport } from "@-/com.npmjs.loglayer__transport-sentry";
import onetime from "@-/com.npmjs.onetime";
import { logger as sentryLogger } from "@sentry/core";
import { buildAppLogLayer, createEnabledConsoleTransports } from "#app-log-layer-common";
import { ORIGINAL_CONSOLE } from "#original-console";

/** Web client accepts no server options; kept for a uniform `getAppLogLayer` signature across runtimes. */
export type AppLogLayerServerOptions = Record<never, never>;

/**
 * The **web** (browser) app LogLayer variant.
 *
 * Transports: `SentryTransport` backed by `@sentry/core`'s
 * `logger` structured-logging API (`Sentry.init({ enableLogs: true })` is
 * already configured on web), plus the app console transport in non-production
 * builds only. This `SentryTransport` supersedes the previous
 * `consola-sentry-reporter` bridge. NO Axiom `HttpTransport`: the `@sensitive`
 * `AXIOM_TOKEN` must never be inlined into a client bundle, so client logs reach
 * Axiom only indirectly (via Sentry and the server pipeline).
 */
export const getAppLogLayer: (options?: AppLogLayerServerOptions) => ILogLayer = onetime(() =>
  buildAppLogLayer([
    ...createEnabledConsoleTransports(ORIGINAL_CONSOLE),
    new SentryTransport({ logger: sentryLogger }),
  ]),
);
